import React from 'react'
import { Edit } from '../../atoms/NewIcons'
import Button from '../../atoms/Button/Button'
import useTrans from '../../../hooks/useTrans'

const MyAccountBlockText = ({ children }) => {
  return <div className="myaccount-block__text">{children}</div>
}

const MyAccountBlock = ({ title, edit, onEditClick, children }) => {
  const t = useTrans()
  return (
    <div className="myaccount-block">
      <div className="myaccount-block__head">
        <h2 className="myaccount-block__title">{title}</h2>
        {edit && (
          <Button
            label={t('Modifica')}
            variant="ghost"
            size="large"
            responsive={true}
            icon={<Edit />}
            icon_pos="right"
            onClick={onEditClick}
            className="myaccount-block__edit-button"
          />
        )}
      </div>
      <div className="myaccount-block__content">{children}</div>
    </div>
  )
}

MyAccountBlock.Text = MyAccountBlockText

export default MyAccountBlock
